import React from "react";
import teamPhoto from "../../assets/images/20th.png";

const MANROPE = { fontFamily: '"Manrope", sans-serif' };

export default function CelebrationHero({ playButtonRef, onPlay }) {
  const prefersReducedMotion =
    typeof window !== "undefined" && window.matchMedia
      ? window.matchMedia("(prefers-reduced-motion: reduce)").matches
      : false;

  const handleReadMore = () => {
    const target = document.getElementById("our-story");
    if (!target) return;
    target.scrollIntoView({ behavior: prefersReducedMotion ? "auto" : "smooth", block: "start" });
  };

  return (
    <section className="relative w-full bg-white pt-20 pb-16 lg:pt-[calc(var(--celebration-banner-height)+147px)]">
      <div className="mx-auto theme-container">
        <h1
          className="mx-auto max-w-3xl text-center text-34 font-semibold text-main-black md:text-48"
          style={MANROPE}
          data-aos="fade-up"
          data-aos-duration="800"
        >
          20 Years of Technology and Innovation
        </h1>

        <div
          className="celebration-hero-media relative mx-auto mt-10 aspect-video w-full max-w-4xl overflow-hidden rounded-[20px] shadow-card"
          data-aos="zoom-in"
          data-aos-duration="800"
        >
          <img
            src={teamPhoto}
            alt="The Informulate team celebrating 20 years"
            className="absolute inset-0 h-full w-full object-cover object-[50%_30%]"
          />
          <div className="absolute inset-0 bg-black/20" aria-hidden="true" />
          <button
            type="button"
            ref={playButtonRef}
            onClick={(e) => onPlay(e.currentTarget)}
            aria-haspopup="dialog"
            aria-label="Play the celebration video"
            className="celebration-play-pulse absolute left-1/2 top-1/2 flex h-16 w-16 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-white/90 transition-transform hover:scale-105 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 md:h-20 md:w-20"
          >
            <span
              className="ml-1 inline-block h-0 w-0 border-y-[14px] border-l-[22px] border-y-transparent border-l-[#22488d]"
              aria-hidden="true"
            />
          </button>
        </div>

        <div className="mt-10 flex justify-center">
          <button
            type="button"
            onClick={handleReadMore}
            className="flex flex-col items-center gap-2 text-sm font-medium text-purple transition-all duration-300 hover:translate-y-1 focus:outline-none focus-visible:ring-2 focus-visible:ring-purple focus-visible:ring-offset-2"
          >
            Read More
            <span
              className={`flex h-10 w-10 items-center justify-center rounded-full border-2 border-purple transition-all duration-300 hover:bg-purple group ${
                prefersReducedMotion ? "" : "top-bottom-moving"
              }`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-purple transition-all duration-300 group-hover:text-white"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  className="transition-all duration-300 group-hover:stroke-[3]"
                  d="M19 14l-7 7m0 0l-7-7m7 7V3"
                />
              </svg>
            </span>
          </button>
        </div>
      </div>
    </section>
  );
}
